import { Card, CardBody, CardHeader, Spinner, Switch } from "@heroui/react"
import { CalendarDaysIcon } from "@heroicons/react/24/outline"
import { Button } from "@heroui/react"
import PropTypes from "prop-types"

const Bookings = ({ handleSave, handleUpdate, isDirty, isLoading, isSaving, unbookOnNonAttendance }) => (
  <Card className="mt-3">
    <CardHeader className="justify-between text-white bg-indigo-700">

      <div className="flex items-center">
        <CalendarDaysIcon className="mr-2 w-14 h-14" />
        
        <div className="flex flex-col">
          <h1 className="text-lg font-semibold">Bookings</h1>
          <p className="text-sm">
            Booking Options
          </p>
        </div>
      </div>

      <Button 
        color="success" 
        className="font-semibold text-white" 
        onPress={() => handleSave()}
        isDisabled={!isDirty || isLoading}
        isLoading={isSaving}
      >
        Save
      </Button>
    </CardHeader>

    <CardBody>          
      <div className="px-4 pb-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Auto Unbook</h3>
            <p className="text-content2-foreground">Automatically unbook bookings that have confirmed non attendance.</p>
          </div>
          
          {isLoading && <Spinner className="ml-8" />}

          {!isLoading && (
            <Switch
              color="success"
              isSelected={unbookOnNonAttendance} 
              onValueChange={(value) => handleUpdate("unbook_on_non_attendance", value)}
            />
          )}
        </div>
      </div>
    </CardBody>
  </Card>
)

Bookings.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  unbookOnNonAttendance: PropTypes.bool.isRequired,
}

export default Bookings